<template>
  <div>
    <div style="background-color: lightgrey">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <van-field v-model="queryFormModel.id" :colon="true" label="ID" placeholder="请输入ID" type="digit"/>
          <van-field v-model="queryFormModel.nickname" :colon="true" label="昵称" placeholder="请输入昵称"/>
<!--          <van-field-->
<!--              :colon="true"-->
<!--              :value="queryFormModel.sex"-->
<!--              clickable-->
<!--              label="性别"-->
<!--              placeholder="请选择性别"-->
<!--              readonly-->
<!--              @click="openPicker(sexColumn,(value)=>{queryFormModel.sex = value})"-->
<!--          />-->
          <van-field
              :colon="true"
              :value="queryFormModel.level"
              clickable
              label="等级"
              placeholder="请选择等级"
              readonly
              @click="openPicker(levelColumn,(value)=>{queryFormModel.level = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.subscribe"
              clickable
              label="是否关注"
              placeholder="请选择"
              readonly
              @click="openPicker(isSubscribeColumn,(value)=>{queryFormModel.subscribe = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.isBlacklist"
              clickable
              label="是否黑名单"
              placeholder="请选择"
              readonly
              @click="openPicker(isBlacklistColumn,(value)=>{queryFormModel.isBlacklist = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.isViolation"
              clickable
              label="是否违规"
              placeholder="请选择"
              readonly
              @click="openPicker(isViolationColumn,(value)=>{queryFormModel.isViolation = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.hasOrder"
              clickable
              label="是否下过单"
              placeholder="请选择"
              readonly
              @click="openPicker(isHasOrderColumn,(value)=>{queryFormModel.hasOrder = value})"
          />
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="onLoad(true)">查询</van-button>
          </div>
          <!--          </van-cell-group>-->
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <van-cell-group>
        <van-cell v-for="(item, index) in list" :key="index" size="large" center clickable is-link :to="'/kf/user/detail/'+ item.id">
          <div class="user-item">
            <div class="left align-center">
              <div class="user_head">
                <van-image round width="60px" height="60px" :src="item.headimgUrl"></van-image>
                <div class="avatarFrame" v-if="item.avatarFrameUrl">
                  <img width="80px" height="80px" :src="item.avatarFrameUrl"/>
                </div>
                <van-tag v-if="item.levelName" class="level" type="primary" round size="medium">
                  {{ item.levelName }}
                </van-tag>
              </div>
              <div class="padding-left-sm">
                <!-- id 已关注 黑名单 -->
                <div class="left-sm-tag">
                  <van-tag plain type="primary">ID：{{ item.id }}</van-tag>
                  <van-tag v-if="item.subscribe == 1" type="success">已关注</van-tag>
                  <van-tag v-else plain>未关注</van-tag>
                  <van-tag v-if="item.violationCount > 0" plain color="#91d5ff" >
                    <a @click.stop.prevent="lookViolation(item.id)">{{ item.violationCount }}条违规</a>
                  </van-tag>
                  <van-tag v-if="item.isBlacklist" type="default" color="black">黑名单</van-tag>
                </div>
                <!-- 用户昵称 1条违规 -->
                <div>
                  <span>{{ item.nickname }}</span>
                </div>
                <!-- 推荐人：xxx -->
                <div v-if="item.distUserNickname" class="recommend">
                    推荐人：{{ item.distUserNickname }}
                </div>
              </div>
            </div>
            <div class="right">
            </div>
          </div>
        </van-cell>
      </van-cell-group>
    </van-list>
    <van-popup v-model="picker.show" position="bottom" round>
      <van-picker
          :columns="picker.columns"
          show-toolbar
          @cancel="onPickerCancel"
          @confirm="onPickerConfirm"
      />
    </van-popup>
    <!--  查看违规内容  -->
    <ViolationSelect :showViolation="showViolation" :userViolationSignList="violationList"
                     @changeShowViolation="changeShowViolation"></ViolationSelect>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Button,
  List,
  Cell,
  CellGroup,
  Tag,
  Dialog,
  Collapse,
  CollapseItem,
  Field,
  Popup,
  Picker,
  Image,
  Checkbox, CheckboxGroup
} from 'vant';
import { getUserList ,lookViolation} from '@/api/user'
import moment from 'moment';
import Decimal from 'decimal.js';
import _ from "lodash";
import ViolationSelect from '@/components/common/violation-select'

Vue.use(Tab)
    .use(Tabs)
    .use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Dialog)
    .use(Image)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Collapse)
    .use(CollapseItem)
    .use(Field)
    .use(Popup)
    .use(Picker)

export default {
  name: 'user-list',
  components: {
    ViolationSelect
  },
  data () {
    return {
      activeNames: [1],
      queryFormModel: {
        id: null,
        nickname: null,
        sex: null,
        level: null,
        subscribe: null,
        isBlacklist: null,
        isViolation: null,
        hasOrder:null
      },
      picker: {
        show: false,
        columns: [],
        onConfirm: null,
        onCancel: null
      },
      levelList: [],
      isSubscribeMap: {
        '未关注': 0,
        '已关注': 1
      },
      isBlacklistMap: {
        '否': 0,
        '是': 1
      },
      isViolationMap: {
        '否': 0,
        '是': 1
      },
      isHasOrderMap: {
        '否': 0,
        '是': 1
      },
      showViolation: false,
      violationList: [],
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  computed: {
    sexColumn() {
      return this.mapEnumToColumn(this.$store.state.ClerkSexEnum)
    },
    levelColumn() {
      return _.filter(this.$store.state.UserGradeMap, (elem) => {
        return elem !== '全部'
      })
    },
    isSubscribeColumn(){
      return Object.keys(this.isSubscribeMap)
    },
    isBlacklistColumn(){
      return Object.keys(this.isBlacklistMap)
    },
    isHasOrderColumn(){
      return Object.keys(this.isHasOrderMap)
    },
    isViolationColumn(){
      return Object.keys(this.isViolationMap)
    },
  },
  methods: {
    //查看违规记录
    lookViolation(userId) {
      this.showViolation = true
      lookViolation(userId).then(res => {
        const data = res.data;
        if (data.code == 0) {
          this.violationList = data.violationList
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    changeShowViolation(val){
      this.showViolation = val
    },
    mapEnumToColumn(Enum) {
      return _.map(Enum.list(), (elem) => {
        return elem.label
      })
    },
    openPicker(columns, onConfirm,onCancel) {
      this.picker.columns = columns
      this.picker.onConfirm = onConfirm
      if(!onCancel){
        onCancel = () => {
          onConfirm(null)
        }
      }
      this.picker.onCancel = onCancel;
      this.picker.show = true
    },
    onPickerConfirm(value) {
      if (this.picker.onConfirm) {
        this.picker.onConfirm(value)
      }
      this.picker.show = false
    },
    onPickerCancel(value) {
      if (this.picker.onCancel) {
        this.picker.onCancel(value)
      }
      this.picker.show = false
    },
    onLoad(resetPage) {
      this.activeNames = []
      this.loading = true
      if (resetPage) {
        this.pageNo = 1;
        this.list = []
      }
      let {
        id,
        nickname,
        sex,
        level,
        subscribe,
        isBlacklist,
        isViolation,
        hasOrder
      } = this.queryFormModel
      if (sex) {
        sex = this._.find(this.$store.state.ClerkSexEnum.list(), (elem) => {
          return elem.label === sex
        }).value;
      }
      if (level) {
        level = (this._.invert(this.$store.state.UserGradeMap))[level]
      }
      if (subscribe) {
        subscribe = this.isSubscribeMap[subscribe]
      }
      if (isBlacklist) {
        isBlacklist = this.isBlacklistMap[isBlacklist]
      }
      if (isViolation) {
        isViolation = this.isViolationMap[isViolation]
      }
      if (hasOrder) {
        hasOrder = this.isHasOrderMap[hasOrder]
      }
      getUserList(id, nickname, sex, level, subscribe, isBlacklist, isViolation,hasOrder,
          this.pageNo, this.pageSize).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          if (data.hasNextPage) {
            this.listFinished = false;
          } else {
            this.listFinished = true;
          }
          for (let i in data.list) {
            let user = data.list[i];
            this.list.push(user)
          }
        } else {
          this.listFinished = true;
          Dialog.alert({
            title: '加载用户失败',
            message: data.msg
          })
        }
        this.pageNo++;
      })
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
  },
  mounted() {
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>
.user-item {
  display: flex;
  align-items: center;
  .userMemo {
    color: #999;
  }
  .left {
    flex: 1;
    display: flex;
    .service-info {
      color: #333;
    }
    .created {
      color: #555;
      margin-bottom: 5px;
    }
    .user_head {
      position: relative;
      padding: 10px;
      .avatarFrame {
        position: absolute;
        top: 0;
        left: 0;
      }
      .level {
        position: absolute;
        left: 50%;
        height: 10px;
        font-size: 10px;
        white-space: nowrap;
        bottom: 0px;
        transform: translateX(-50%);
      }
    }

    .padding-left-sm div span{
      margin-right: 5px;
    }
    .recommend{
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #999999;
    }
  }
  .right {
    text-align: right;
    min-width: 30px;
    .total-amount {
      color: #333;
    }
  }
}

.type-title{
  display: inline-block;
  position: relative;
  top: -5px;
  padding-left: 10px;
  color: #999999;
  font-size: 14px;
}

</style>
